export const MATERIAL_TYPES = ["Şişe", "Kutu", "Etiket", "Kapak", "Pompa", "Valf", "Kavanoz", "Koli", "Aparat", "Diğer"];

export const MAT_STATUS = {
  ok: { label: "Yeterli", dot: "bg-emerald-500", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  warning: { label: "Yaklaşıyor", dot: "bg-amber-500", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  critical: { label: "Kritik", dot: "bg-rose-500", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  out: { label: "Stok Yok", dot: "bg-rose-600", cls: "bg-rose-100 text-rose-800 border-rose-400" },
  negative: { label: "Kritik / Eksik", dot: "bg-rose-700", cls: "bg-rose-100 text-rose-900 border-rose-500" },
};

export const EMPTY_MATERIAL = {
  name: "", material_type: "Şişe", usage_qty: 1, stock_qty: 0, critical_stock: 0, unit: "Adet",
  default_supplier_id: "", note: "", active: true,
};
